import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { DataStorageService } from "assurcard-angular-library";
import { Subscription } from "rxjs";
import { keepAlive } from "src/app/kiosk/state/kiosk.actions";
import { AppState, getState } from "src/app/state/app.state";
import { environment } from "src/environments/environment";
import { setShowScreenSaver } from "../../transaction-info/state/transaction-info.actions";

@Component({
    selector: "app-screen-saver",
    templateUrl: "./screen-saver.component.html",
    styleUrls: ["./screen-saver.component.scss"],
    standalone: false
})
export class ScreenSaverComponent implements OnInit,OnDestroy {
	private subs: Subscription[] = [];

	constructor(private store: Store<AppState>,private dataStorage:DataStorageService, private router: Router) {
		if (environment.kioskMode) {
			this.subs.push(
				getState(this.store).subscribe(state =>{
					const token = state.authentication.token;
					const kioskId = state.transactionInfo.kioskId;
					if (token == undefined || kioskId == undefined) return;
					this.store.dispatch(keepAlive({ kioskId: kioskId }));
				})
			);		
		}
	}

	ngOnInit() {
		this.dataStorage.remove('CURRENT_LANG').subscribe()
	}


	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}

	@HostListener('document:mousemove', ['$event'])
	onMouseMove(e): void {
		this.store.dispatch(setShowScreenSaver({ data: false }));
	}
}
